import React, { Component } from 'react';

export const ProductContext = React.createContext();

export class ProductProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: null,
    };
  }

  updateProductState = (value) => {
    this.setState({
      product: value,
    });
  };

  render() {
    return (
      <ProductContext.Provider
        value={{
          product: this.state.product,
          updateProductState: this.updateProductState,
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/context/ProductContext.js